import React, { Component } from "react";
import Header from "../common/Header";
import Sidebar from "./Sidebar";

import { Link } from "react-router-dom";

import NumberFormat from "react-number-format";

import axios from "axios";
import swal from "sweetalert";
import $ from "jquery";

export class VolunteerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage["appState"]
        ? JSON.parse(localStorage["appState"]).user.token
        : "",
      user: [],
    };
  }

  componentDidMount() {
    this.getUser();
  }

  getUser() {
    let id = window.location.href.split("/")[
      window.location.href.split("/").length - 1
    ];

    axios
      .get(`${axios.defaults.baseURL}/volunteer/${id}`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({ user: json.data.volunteer});
          // } else alert("Cannot Fetch Data!");
        } else swal("Oops!", "Cannot Fetch Data!", "error");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
    // alert(id)
  }

  approveVolunteer(id) {

    axios({
        method: 'post',
        url: `${axios.defaults.baseURL}/volunteer/approve/${id}`
        })
      .then((response) => {
        //console.log(response);
        swal("Success!", response.data.message, "success", {
            button: false,
            timer: 1500
          });
        return response;
      })
  };

  rejectVolunteer(id) {

    axios({
        method: 'post',
        url: `${axios.defaults.baseURL}/volunteer/reject/${id}`
        })
      .then((response) => {
        //console.log(response);
        swal("Success!", response.data.message, "danger", {
            button: false,
            timer: 1500
          });
        return response;
      })
  };

  render() {
    return (
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <div className="page-title">
                    <div className="row text-primary py-2 pt-4">
                      <div className="col-10">
                        <div
                          className="user-welcome"
                          style={{ overflow: "hidden" }}
                        >
                          <Link to="/admin/volunteers-list">
                            <i className="ti-arrow-left"></i> Back to Volunteer Applications
                          </Link>
                          <div className="wrapper d-flex mt-2">
                            <h4 className="d-inline-block">
                              View Application
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="text-right col-2"></div>
                    </div>
                  </div>

                  <div>
                    <div
                      data-v-22924209=""
                      class="dash-card-plan bg-white mb-4"
                    >
                      <div className="row">
                        <div className="col-md-4 text-center">
                            <a href={this.state.user.certificate} target="_blank"><img src={this.state.user.certificate} className="volunteer-img p-2" alt="" /></a>
                            <p>Click image to view</p>
                            <br/>
                            <br/>
                            <Link onClick={this.rejectVolunteer.bind(this, this.state.user.id)} className="btn mr-2 btn-danger">
                                  Reject
                              </Link>
                              <Link onClick={this.approveVolunteer.bind(this, this.state.user.id)} className="btn mr-2 btn-success">
                                  Approve
                              </Link>
                        </div>
                        <div className="col-md-8">
                          <div className="p-4">
                          <div className="">
                                  <h5 className="mb-0">Personal Details</h5>
                                </div>
                            <br />
                            <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1 titlecase">
                                  <b>Firstname: {this.state.user.fname}</b>
                                </p>
                              </div>
                              <div className="col">
                                <p className="mb-1 titlecase">
                                    <b>Lastname: {this.state.user.lname}</b>
                                    </p>
                              </div>
                            </div>
                            <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1">
                                  <b>Email: {this.state.user.email}</b>
                                </p>
                              </div>
                              <div className="col">
                                <p className="mb-1 titlecase">
                                    <b>Telephone: {this.state.user.phone}</b>
                                    </p>
                              </div>
                            </div>
                            <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1">
                                  <b>Country: {this.state.user.country}</b>
                                </p>
                              </div>
                              <div className="col">
                                <p className="mb-1 titlecase">
                                    <b>State: {this.state.user.state}</b>
                                    </p>
                              </div>
                            </div>
                            <div className="row mb-4">
                            <div className="col">
                                <p className="mb-1 titlecase">
                                  <b>City: {this.state.user.city}</b>
                                </p>
                              </div>
                              <div className="col">
                                <p className="mb-1 titlecase">
                                  <b>Address: {this.state.user.address}</b>
                                </p>
                              </div>
                            </div>
                            <br/>
                            <div className="">
                                  <h5 className="mb-4">Application</h5>
                                </div>

                            <div className="">
                                <p className="mb-1 titlecase"><b>Why I want join:<br/>{this.state.user.why}</b>
                                </p>
                              </div><br/>
                                <div className="row mb-4">
                              <div className="col">
                                <p className="mb-1 titlecase">
                                  <b>Supreme Court ID: {this.state.user.supremeid}</b>
                                </p>
                              </div>
                              <div className="col">
                                <p className="mb-1 titlecase">
                                  <b>Application Status: {this.state.user.status}</b>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                </div>
                </div>
                
        </div>
      </div>
    );
  }
}

export default VolunteerDetails;
